export default __webpack_public_path__ + "static/media/2930 utensils top.ab810474.png";